import { lazy, Suspense } from 'react'

const ConnectedTimelinesComponent = lazy(() => import('.'))

export const ConnectedTimelines: React.VFC = (props) => (
  <Suspense fallback={null}>
    <ConnectedTimelinesComponent {...props} />
  </Suspense>
)
